import { PlusOutlined, SearchOutlined, FileExcelOutlined, CopyOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Col, Dropdown, Input, Menu, message, Pagination, Popconfirm, Row, Space, Table, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { useCallback, useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { font } from '../../../Common/font';
import { ReactComponent as Archiveicon } from '../../../Images/Archiveicon.svg';
import { ReactComponent as Back } from '../../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../../Images/ColumnList.svg';
import { ReactComponent as EditIcon } from '../../../Images/EditIcon.svg';
import { ReactComponent as FilterIcon } from '../../../Images/FilterIcon.svg';
import { ReactComponent as PlanPrintIcon } from '../../../Images/SimplePrintIcon.svg';
import { ReactComponent as PrintIcon } from '../../../Images/PrintIcon.svg';
import { ReactComponent as ViewIcon } from '../../../Images/ViewIcon.svg';
import { ReactComponent as Archive } from '../../../Images/archive.svg';
import  SalesOrderIcon  from '../../../Images/sales-order.png';
import { deleteSalesOrder, fetchSalesOrdersList, resetSalesOrderData } from '../../../slices/sales-order';
import { createActivityLog } from '../../../slices/activity-log';
import { fetchAndSetIpAddress } from '../../../slices/ipSlice';
import eventBus from '../../../utils/eventBus';
import { CSVLink } from 'react-csv';
import jsPDF from 'jspdf';
import moment from 'moment';
import logo from '../../../Images/alux-logo.png';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

function SalesOrderList() {
  const [orderBy, setOrderBy] = useState('');
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState(localStorage.getItem('salesOrderList') || '');
  const [inputValue, setInputValue] = useState(localStorage.getItem('salesOrderList') || '');
  const [pagesize, setPageSize] = useState(100);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const csvLinkRef = useRef(null);
  const [csvData, setCsvData] = useState([]);
  const { data = [], totalRecord, loading } = useSelector(state => state.salesOrder);
  const { user: currentUser } = useSelector(state => state.auth);
  const ipAddress = useSelector(state => state.ip.ipAddress);

  useEffect(() => {
    if (!ipAddress) {
      dispatch(fetchAndSetIpAddress());
    }
  }, [ipAddress, dispatch]);


  const fetchSalesOrders = useCallback(() => {
    dispatch(
      fetchSalesOrdersList({
        page,
        pagesize,
        ...(search && { search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
  }, [dispatch, page, pagesize, search, orderBy]);

  useEffect(() => {
     dispatch(resetSalesOrderData());
    fetchSalesOrders();
  }, [fetchSalesOrders]);

   useEffect(() => {
    const handleReload = () => {
      fetchSalesOrdersList();
    };

    eventBus.on("financialYear:refresh", handleReload);

    return () => {
      eventBus.off("financialYear:refresh", handleReload);
    };
  }, [fetchSalesOrders]);

  const debouncedFetch = useRef(
    debounce((searchTerm, page, pagesize, orderBy) => {
      fetchSalesOrders({ page, pagesize, search: searchTerm, orderBy });
    }, 500)
  ).current;

  useEffect(() => {
    if (search !== undefined && search !== '' && search === inputValue) {
      debouncedFetch(search, 1, pagesize, orderBy);
      setPage(1);
    }
  }, [inputValue, search, debouncedFetch, orderBy, pagesize]);


  const handleSearch = e => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('salesOrderList', value);
    if (value === '') {
      setPage(1);
      fetchSalesOrders({ page: 1, pagesize, search: '', orderBy });
    }
  };

  const handlePrintDownloadAll = async () => {
    const count = totalRecord;
    if (count > 0) {
      try {

        const response = await dispatch(
          fetchSalesOrdersList({
            page: 1,
            pagesize: count,
            ...(search && { search }),
            ...(orderBy && { ordering: orderBy }),
          }),
        ).unwrap();
        const salesorderDetails = response?.results?.data;
        if (salesorderDetails && salesorderDetails.length > 0) {
          const createPDF = (includePrintText, pdfData) => {
            const pdf = new jsPDF('p', 'pt', 'a4');
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            pdf.addFileToVFS('WorkSans-normal.ttf', font);
            pdf.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal');
            pdf.setFont('WorkSans');
            const pdfColumns = [
              {
                header: 'Sr No.',
                dataKey: 'SrNo',
                field: 'SrNo'
              },
              {
                header: 'Order No',
                dataKey: 'sales_order_no',
                field: 'sales_order_no'
              },
              {
                header: 'Order Date',
                dataKey: 'order_date',
                field: 'order_date',
              },
              {
                header: 'PO No.',
                dataKey: 'purchase_order_number',
                field: 'purchase_order_number',
              },
              {
                header: 'PO Date',
                dataKey: 'purchase_order_date',
                field: 'purchase_order_date',
              },
              {
                header: 'Customer Name',
                dataKey: 'customer_name',
                field: 'customer_name',
              },
              { header: 'Converted Date', dataKey: 'workorder_converted_date', field: 'workorder_converted_date' },
              {
                header: 'Status',
                dataKey: 'status',
                field: 'status'
              },
              {
                header: 'Created At',
                dataKey: 'created_at',
                field: 'created_at',
              },
              {
                header: 'Created By',
                dataKey: 'created_by',
                field: 'created_by',
              },
              {
                header: 'Updated At',
                dataKey: 'updated_at',
                field: 'updated_at',
              },
              {
                header: 'Updated By',
                dataKey: 'updated_by',
                field: 'updated_by',
              },
            ];

            const pdffilteredColumns = pdfColumns.filter(column =>
              checkedList.includes(column.dataKey),
            );

            const rows = pdfData.map((item, index) => {
              return {
                SrNo: index + 1,
                order_date: item?.order_date ? dayjs(item.order_date).format('DD-MM-YYYY') : 'N/A',
                sales_order_no: item?.sales_order_no || 'N/A',
                purchase_order_number: item?.purchase_order_number || 'N/A',
                purchase_order_date: item?.purchase_order_date ? dayjs(item.purchase_order_date).format('DD-MM-YYYY') : 'N/A',
                customer_name: item?.customer_name || 'N/A',
                workorder_converted_date: item?.workorder_converted_date ? dayjs(item.workorder_converted_date).format('DD-MM-YYYY') : 'N/A',
                status: item?.status || 'N/A',
                created_at: item?.created_at
                  ? moment(item.created_at).format('DD-MM-YYYY')
                  : 'N/A',
                created_by: item?.created_by
                  ? `${item.created_by.first_name} ${item.created_by.last_name}`
                  : 'N/A',
                updated_at: item?.updated_at
                  ? moment(item.updated_at).format('DD-MM-YYYY')
                  : 'N/A',
                updated_by: item?.updated_by
                  ? `${item.updated_by.first_name} ${item.updated_by.last_name}`
                  : 'N/A',

                _originalItem: item,
              };
            });
            pdf.text('Sales Orders List', pdf.internal.pageSize.width / 2, 40, {
              align: 'center',
            });
            pdf.autoTable({
              head: [pdffilteredColumns.map(col => col.header)],
              body: rows.map(row =>
                pdffilteredColumns.map(col => row[col.dataKey]),
              ),
              startY: 65,
              theme: 'grid',
              styles: {
                font: 'times',
                halign: 'center',
                fontSize: 7,
                overflow: 'linebreak',
                cellPadding: 3.5,
                lineWidth: 0.5,
                lineColor: [0, 0, 0],
                textColor: [0, 0, 0],
              },
              headStyles: {
                textColor: [0, 0, 0],
                fontStyle: 'bold',
                lineWidth: 0.5,
                lineColor: [0, 0, 0],
                fillColor: false,
              },
              tableLineColor: [0, 0, 0],
              rowPageBreak: 'avoid',
              margin: { top: 65, left: 20, right: 20, bottom: 30 },

              didDrawPage: data => {
                const pageCount = pdf.internal.getNumberOfPages();
                const pageNumber = pdf.internal.getNumberOfPages();
                const str = `Page ${pageNumber}`;
                const dateStr = new Date().toLocaleString();
                pdf.setFontSize(10);
                pdf.text(dateStr, 40, pageHeight - 20);
                pdf.text(str, pageWidth - 60, pageHeight - 20);
                if (pageNumber === 1) {
                  pdf.addImage(logo, 'PNG', pageWidth - 100, 10, 90, 30);
                }
              },
            });

            return pdf;
          };
          const printPDF = createPDF(true, salesorderDetails);
          const pdfBlob = printPDF.output('blob');
          const iframe = document.createElement('iframe');
          iframe.style.position = 'fixed';
          iframe.style.right = '0px';
          iframe.style.bottom = '0px';
          iframe.style.width = '1px';
          iframe.style.height = '1px';
          iframe.style.border = 'none';
          iframe.src = URL.createObjectURL(pdfBlob);
          document.body.appendChild(iframe);
          iframe.onload = () => {

            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          };
          dispatch(
            createActivityLog({
              action: 'PRINT',
              module_name: 'salesOrder',
              ip_address: ipAddress,
              discription: 'Sales Order print download successfully!',
            }),
          );


        } else {

          console.warn('No work order details found.');
        }
      } catch (error) {

        console.error('Failed to fetch or generate PDF:', error);
      }
    }
  };

  const handleEdit = useCallback(record => navigate(`/edit-sales-order/${record.id}`), [navigate]);

  const handleDelete = id => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }
    dispatch(deleteSalesOrder(id))
      .unwrap()
      .then(() => {
        message.success('Sales Order Archived Successfully!');
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          messages.length > 0
            ? message.error(messages.join('; '))
            : message.error('An unknown error occurred.');
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'sales_order_no',
    'order_date',
    'purchase_order_number',
    'purchase_order_date',
    'customer_name',
    'workorder_converted_date',
    'status',
    'action'
  ]);

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: 100,
      render: (text, record, index) => {
        return (page - 1) * pagesize + index + 1;
      },
    },
    {
      title: 'Order No.',
      dataIndex: 'sales_order_no',
      key: 'sales_order_no',
      render: sales_order_no => {
        return <span>{sales_order_no || 'N/A'}</span>;
      },
      sorter: true,
    },
    {
      title: 'Order Date',
      dataIndex: 'order_date',
      key: 'order_date',
      sorter: true,
      render: order_date => {
        return (
          <span>
            {order_date ? dayjs(order_date).format('DD-MM-YYYY') : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'PO No.',
      dataIndex: 'purchase_order_number',
      key: 'purchase_order_number',
      sorter: true,
      render: purchase_order_number => {
        return <span>{purchase_order_number || 'N/A'}</span>;
      },
    },
    {
      title: 'PO Date',
      dataIndex: 'purchase_order_date',
      key: 'purchase_order_date',
      sorter: true,
      render: purchase_order_date => {
        return (
          <span>
            {purchase_order_date ? dayjs(purchase_order_date).format('DD-MM-YYYY') : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer_name',
      sorter: true,
      render: customer_name => {
        return <span>{customer_name || 'N/A'}</span>;
      },
      key: 'customer_name',
    },
    {
      title: 'Converted Date',
      dataIndex: 'workorder_converted_date',
      key: 'workorder_converted_date',
      sorter: true,
      render: workorder_converted_date => {
        return (
          <span>
            {workorder_converted_date
              ? dayjs(workorder_converted_date).format('DD-MM-YYYY')
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      render: record => {
        return (
          <span>
            {record ? dayjs(record).format('DD-MM-YYYY hh:mm A') : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      sorter: true,
      render: record => {
        return (
          <span>
            {record ? `${record.first_name} ${record.last_name}` : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      render: record => {
        return (
          <span>
            {record && record.trim()
              ? dayjs(record).format('DD-MM-YYYY HH:mm')
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Updated By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      sorter: true,
      render: record => {
        return (
          <span>
            {record && record.first_name?.trim() && record.last_name?.trim()
              ? `${record.first_name} ${record.last_name}`
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 150,
      render: record => (
        <Space>
          <>
            {currentUser.permissions.permissions.inquiry_salesorder.includes(
              'view_inquirysalesorder',
            ) && (
                <Tooltip title="View">
                  <Link to={`/view-sales-order/${record.id}`}>
                    <ViewIcon />
                  </Link>
                </Tooltip>
              )}
            {[
              'print_inquiry_salesorder'
            ].some(permission =>
              currentUser.permissions.permissions.inquiry_salesorder.includes(
                permission,
              ),
            ) && (
                <a
                  href={`/print-sales-order/${record.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Tooltip title="Print">
                    <PlanPrintIcon />
                  </Tooltip>
                </a>
              )}
          </>

          {currentUser.permissions.permissions.inquiry_salesorder.includes(
                        'print_inquiry_salesorder',
                      ) && (
                          <Tooltip title="Convert to Work Order">
                            <Link
                              to={`/create-sales-order-work-order/${record?.id}`}
                              rel="noopener noreferrer"
                            >
                              <img src={SalesOrderIcon} alt="sales order" width="22" height="22"/>
                            </Link>
                          </Tooltip>
                        )}

          {currentUser.permissions.permissions.inquiry_salesorder.includes(
            'change_inquirysalesorder',
          ) && (
              // record?.workorder_type !== 'Job Work' &&
              <Tooltip placement="top" title={'Edit'}>
                <span
                  onClick={() => handleEdit(record)}
                  style={{ cursor: 'pointer' }}
                >
                  <EditIcon />
                </span>
              </Tooltip>
            )}
          {currentUser.permissions.permissions.inquiry_salesorder.includes(
            'delete_inquirysalesorder',
          ) && (

              <Tooltip title="Archive">
                <Popconfirm
                  title="Are you sure you want to archive this record?"
                  onConfirm={() => handleDelete(record.id)} // Correctly access `id`
                  onCancel={() => message.info('Action cancelled')}
                  okText="Yes"
                  cancelText="No"
                >
                  <Link>
                    <Archive />
                  </Link>
                </Popconfirm>
              </Tooltip>
            )}
        </Space>
      ),
    },
  ];

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };
  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={checkedValues => {
            handleColumnVisibilityChange(checkedValues);
          }}
        >
          <Row gutter={16}>
            <Col xs={12} md={12}>
              <Checkbox value="SrNo" disabled>
                Sr.No.
              </Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="sales_order_no">Order No</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="order_date">Order Date</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="purchase_order_number">PO No.</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="purchase_order_date">PO Date</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="customer_name">Customer Name</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="workorder_converted_date">Converted Date</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="status">Status</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="created_at">Created At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="created_by">Created By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_at">Updated At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_by">Updated By</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const csvheaders = [
    { label: 'Sr. No', key: 'SrNo' },
    { label: 'Order Date', key: 'order_date' },
    { label: 'Order No.', key: 'sales_order_no' },
    { label: 'PO No.', key: 'purchase_order_number' },
    { label: 'PO Date', key: 'purchase_order_date' },
    { label: 'Customer Name', key: 'customer_name' },
    { label: 'Converted Date', key: 'workorder_converted_date' },
    { label: 'Status', key: 'status' },
    { label: 'Created At', key: 'created_at' },
    { label: 'Created By', key: 'created_by' },
    { label: 'Updated At', key: 'updated_at' },
    { label: 'Updated By', key: 'updated_by' },
  ];

  const csvFilterheaders = csvheaders.filter(column =>
    checkedList.includes(column.key),
  );

  const handleExcel = async () => {
    const count = totalRecord;
    if (count > 0) {

      try {
        const response = await dispatch(
          fetchSalesOrdersList({
            page: 1,
            pagesize: count,
            ...(search && { search }),
            ...(orderBy && { ordering: orderBy }),
          })
        ).unwrap();

        const workOrderData = response.results?.data || response;

        // filter headers dynamically
        const selectedHeaders = csvFilterheaders.map(h => h.label);

        const excelData = workOrderData.map((item, index) => {
          const row = {
            'Sr. No': index + 1,
            'Order Date': item.order_date ? moment(item.order_date).format('DD-MM-YYYY') : 'N/A',
            'Order No.': item.sales_order_no || 'N/A',
            'PO No.': item.purchase_order_number || 'N/A',
            'PO Date': item.purchase_order_date ? moment(item.purchase_order_date).format('DD-MM-YYYY') : 'N/A',
            'Customer Name': item.customer_name || 'N/A',
            'Converted Date': item?.workorder_converted_date ? moment(item.workorder_converted_date).format('DD-MM-YYYY') : 'N/A',
            'Status': item.status || 'N/A',
            'Created At': item.created_at ? moment(item.created_at).format('DD-MM-YYYY') : 'N/A',
            'Created By': item.created_by ? `${item.created_by.first_name} ${item.created_by.last_name}` : 'N/A',
            'Updated At': item.updated_at ? moment(item.updated_at).format('DD-MM-YYYY') : 'N/A',
            'Updated By': item.updated_by ? `${item.updated_by.first_name} ${item.updated_by.last_name}` : 'N/A',
          };

          // keep only selected headers
          return Object.fromEntries(
            Object.entries(row).filter(([key]) => selectedHeaders.includes(key))
          );
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'SalesOrders');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, 'SalesOrders.xlsx');
      } catch (error) {
        console.error('Failed to fetch sales order data:', error);
      } finally {

      }
    }
  };


  const handlePageChange = newPage => {
    setPage(newPage);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';
    if (sortField === 'SrNo' && sortOrder === 'ascend') {
      sortingEnumKey = 'SrNo';
    }
    if (sortField === 'SrNo' && sortOrder === 'descend') {
      sortingEnumKey = '-SrNo';
    }
    if (sortField === 'order_date' && sortOrder === 'ascend') {
      sortingEnumKey = 'order_date';
    }
    if (sortField === 'order_date' && sortOrder === 'descend') {
      sortingEnumKey = '-order_date';
    }
    if (sortField === 'sales_order_no' && sortOrder === 'ascend') {
      sortingEnumKey = 'sales_order_no';
    }
    if (sortField === 'sales_order_no' && sortOrder === 'descend') {
      sortingEnumKey = '-sales_order_no';
    }
    if (sortField === 'purchase_order_number' && sortOrder === 'ascend') {
      sortingEnumKey = 'purchase_order_number';
    }
    if (sortField === 'purchase_order_number' && sortOrder === 'descend') {
      sortingEnumKey = '-purchase_order_number';
    }
    if (sortField === 'customer_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'customer_name';
    }
    if (sortField === 'customer_name' && sortOrder === 'descend') {
      sortingEnumKey = '-customer_name';
    }
    if (sortField === 'status' && sortOrder === 'ascend') {
      sortingEnumKey = 'status';
    }
    if (sortField === 'status' && sortOrder === 'descend') {
      sortingEnumKey = '-status';
    }
    if (sortField === 'created_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_by__first_name';
    }
    if (sortField === 'created_by' && sortOrder === 'descend') {
      sortingEnumKey = '-created_by__first_name';
    }
    if (sortField === 'created_by__last_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_by__last_name';
    }
    if (sortField === 'created_by__last_name' && sortOrder === 'descend') {
      sortingEnumKey = '-created_by__last_name';
    }
    if (sortField === 'updated_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_by__first_name';
    }
    if (sortField === 'updated_by' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_by__first_name';
    }
    if (sortField === 'updated_by__last_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_by__last_name';
    }
    if (sortField === 'updated_by__last_name' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_by__last_name';
    }
    return sortingEnumKey;
  };

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
  };

  const handlePageSizeChange = (current, size) => {
    setPage(1);
    setPageSize(size);
  };

  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    localStorage.removeItem('SalesOrderList');
    setPage(1);
    fetchSalesOrders({ page: 1, pagesize, search: '', orderBy: '' });
  };

  const dataSource = data.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (page - 1) * pagesize + index + 1,
  }));
  const dynamicColumns = columns.filter(column =>
    checkedList.includes(column.dataIndex || column.key),
  );
  const handleCopy = async () => {
    try {
      const workOrderDetails = data;
     
      if (workOrderDetails && workOrderDetails.length > 0) {
        const columnLabels = {
          SrNo: 'Sr. No.',
          order_date: 'Order Date',
          order_no: 'Order No.',
          purchase_order_no: 'PO No.',
          customer_name: 'Customer Name',
          status: 'Status',
          created_at: 'Created At',
          created_by: 'Created By',
          updated_at: 'Updated At',
          updated_by: 'Updated By',
        };
        const filteredCheckedList = checkedList.filter(col => col !== 'action');
        const headers = filteredCheckedList.map(
          col => columnLabels[col] || col,
        );
        let tableText = headers.join('\t') + '\n';
        workOrderDetails.forEach((item, index) => {
          const row = filteredCheckedList.map(col => {
            // Sr. No. logic
            if (col === 'SrNo') {
              return (page - 1) * pagesize + index + 1;
            }

            // Days Left logic

            if (col === 'created_at' || col === 'updated_at') {
              return item[col]
                ? dayjs(item[col]).format('DD-MM-YYYY HH:mm')
                : 'N/A';
            }

            if (col === 'created_by') {
              if (!item[col]) return 'N/A';
              const first = item[col].first_name || '';
              const last = item[col].last_name || '';
              const fullName = `${first} ${last}`.trim();
              return fullName || 'N/A';
            }

            if (col === 'updated_by') {
              if (!item[col]) return 'N/A';
              const first = item[col].first_name || '';
              const last = item[col].last_name || '';
              const fullName = `${first} ${last}`.trim();
              return fullName || 'N/A';
            }
            // Default column value
            return item[col] ?? '';
          });

          tableText += row.join('\t') + '\n';
        });
        await navigator.clipboard.writeText(tableText);
      } else {
        console.warn('No salesorder details found.');
      }
    } catch (error) {
      console.error('Failed to fetch or copy:', error);
    }
  };

  const activityLog = async () => {
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'SalesOrder',
        ip_address: ipAddress,
        discription: 'SalesOrder excel download successfully!',
      }),
    );
  };
  return (
    <div className="mainwrap">
      <div className="sticyaction">
        <Row
          className="pagenamerow mb-0"
          justify="space-between"
          align="middle"
        >
          <Col>
            <h2>Sales Orders</h2>
            <div className="bredcrumbwrp">
              <Link onClick={() => navigate(-1)} className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/dashboard">Home</Link> },
                  { title: 'Sales Orders' },
                ]}
              />
            </div>
          </Col>
          {/* Insert 3 color containers here */}

          <Col>
            <Space size="small">
              <Input
                placeholder="Search"
                className="searchbox"
                prefix={<SearchOutlined />}
                value={inputValue}
                style={{ width: 190 }}
                onChange={handleSearch}
                onPressEnter={() => { }} // Disable Enter key trigger if unwanted
              />
              <Link>
                <Tooltip title="Filter">
                  <Button
                    type="primary"
                    disabled={!search && !orderBy}
                    className="iconlink"
                    onClick={resetFilter}
                  >
                    <FilterIcon />
                  </Button>
                </Tooltip>
              </Link>
              {currentUser.permissions.permissions.inquiry_salesorder.includes(
                'download_inquiry_salesorder_excel_copy',
              ) && (
                  <Tooltip title={'Copy Sales Order List to Clipboard'}>
                    <Button
                      type="primary"
                      className="iconlink"
                      onClick={handleCopy}
                    >
                      <CopyOutlined />
                    </Button>
                  </Tooltip>
                )}
              {currentUser.permissions.permissions.inquiry_salesorder.includes(
                'download_inquiry_salesorder_pdf_copy',
              ) && (
                  <Tooltip placement="top" title="Export Excel">
                    <Button
                      type="primary"
                      className="iconlink"
                      style={{ width: '10px' }}
                      onClick={handleExcel} // Call handleExcel on button click
                      loading={loading}
                    >
                      <FileExcelOutlined />
                      <CSVLink
                        filename="salesOrder.csv"
                        className="iconlink"
                        style={{ display: 'none' }} // Hide the CSVLink
                        data={csvData}
                        headers={csvFilterheaders}
                        ref={csvLinkRef}
                      />
                    </Button>
                  </Tooltip>
                )}
              {currentUser.permissions.permissions.inquiry_salesorder.includes(
                'print_inquiry_salesorder',
              ) && (
                  <Tooltip title="Print">
                    <Button
                      type="primary"
                      className="iconlink"
                      onClick={handlePrintDownloadAll}
                    >
                      <PrintIcon />
                    </Button>
                  </Tooltip>
                )}
              {/* {currentUser.permissions.permissions.workorder.includes(
                'add_workorder',
              ) && (
                  <Link to="/add-sales-order">
                    <Tooltip title="Create Work Order">
                      <Button type="primary" icon={<PlusOutlined />}>
                        Create Sales Order
                      </Button>
                    </Tooltip>
                  </Link>
                )} */}

              {currentUser.permissions.permissions.inquiry_salesorder.includes(
                'delete_inquirysalesorder',
              ) && (
                  <Link to="/archive-sales-order-list" className="iconlink">
                    <Tooltip title="Archive">
                      <Archiveicon />
                    </Tooltip>
                  </Link>
                )}
              <div className="gridiconswrap">
                <Tooltip placement="topLeft" title="Column Filter Options">
                  <Dropdown
                    overlay={columnMenu}
                    trigger={['click']}
                    placement="bottomRight"
                    open={dropdownVisible}
                    onVisibleChange={setDropdownVisible}
                  >
                    <Button
                      type="primary"
                      icon={<ColumnList />}
                      onClick={e => e.preventDefault()}
                    />
                  </Dropdown>
                </Tooltip>
              </div>
            </Space>
          </Col>
        </Row>
      </div>
      <div className="tablewrp">
        <Table
          rowKey="id"
          columns={dynamicColumns}
          dataSource={dataSource}
          pagination={false}
          loading={loading}
          scroll={{ x: '600px' }}
          onChange={handleTableChange}
        />
      </div>

      <Pagination
        current={page}
        pageSize={pagesize}
        total={totalRecord}
        showSizeChanger
        onShowSizeChange={handlePageSizeChange}
        pageSizeOptions={['20', '50', '100']}
        showTotal={total => `Total ${total} items`}
        onChange={handlePageChange}
        locale={{ items_per_page: 'Items / Page' }}
      />
    </div>
  );
}

export default SalesOrderList;
